module.exports = __webpack_public_path__ + "static/dark-inkblot-logo-65fe4a6cfbbe3afa363ee60c00c18a70.png";